import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card, CardBody, Button } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <main className="hn-payment-main">
        <Container className="py-5">
          <Card className="hn-payment-card">
            <CardBody className="text-center py-5">
              <h1 className="hn-payment-title mb-3">Subscription started</h1>
              <p className="text-muted mb-4">
                Thanks — your subscription is being activated. This can take a moment.
              </p>
              <Button color="warning" onClick={() => navigate("/dashboard")}>
                Go to dashboard
              </Button>
            </CardBody>
          </Card>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default PaymentSuccessPage;

